module.exports = __webpack_public_path__ + "img/goods1_1.f5d4794c.jpg";